import { SVGProps } from 'react';

export default function FooterLogo(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" transform="matrix(-1 0 0 1 40 0)" fill="#E1F0E6"/>
    <path d="M23.53 12H16.4282C14.0052 12 12 14.0052 12 16.4282V23.5718C12 25.9948 14.0052 28 16.4282 28H23.53C25.953 28 27.9582 25.9948 28 23.5718V16.47C28 14.0052 25.9948 12 23.53 12ZM19.9791 23.7807C17.8903 23.7807 16.2193 22.1097 16.2193 20.0209C16.2193 17.9321 17.8903 16.3029 19.9373 16.3029C21.9843 16.3029 23.6554 17.9739 23.6554 20.0209C23.6554 22.0679 22.0261 23.7807 19.9791 23.7807ZM25.8277 15.9269C25.4935 16.47 24.7833 16.6789 24.282 16.3446C23.7389 16.0104 23.53 15.3003 23.8642 14.799C24.1984 14.2559 24.9086 14.047 25.4099 14.3812C25.953 14.6736 26.1201 15.3838 25.8277 15.9269Z" fill="#213735"/>
    </svg>
  );
} 
